// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/styles/application.scss
// module id = 1673
// module chunks = 5